import React, { useState } from "react";
import { renderMarkdown } from '../utils/renderMarkdown';
import { Modal } from "reactstrap";
import API from "../Network/API";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import "./PostShareModal.css";
// toast.configure() removed — ToastContainer is mounted globally in App.js

const SocialIcons = {
    whatsapp: (
        <svg viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
    ),
    facebook: (
        <svg viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
    ),
    x: (
        <svg viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
    ),
    telegram: (
        <svg viewBox="0 0 24 24"><path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
    ),
    linkedin: (
        <svg viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
    ),
    email: (
        <svg viewBox="0 0 24 24"><path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 2v.511l-8 4.978-8-4.978V6h16zM4 18V8.868l7.47 4.648a1 1 0 001.06 0L20 8.868V18H4z"/></svg>
    ),
    more: (
        <svg viewBox="0 0 24 24"><path d="M13 5.828V17h-2V5.828L7.757 9.071 6.343 7.657 12 2l5.657 5.657-1.414 1.414L13 5.828zM4 16v4h16v-4h2v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5h2z"/></svg>
    ),
};

export default function PostShareModal(props) {
    // { isModalVisible, handleShowB, postId, post_data }
    const { t } = useTranslation();
    const [share_comment, setShareComment] = useState("");
    const [isLoading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);

    const myArr = JSON.parse(localStorage.getItem('user_data'));
    const post_data = props.post_data || {};

    const postUrl = `${window.location.origin}/post/${props.postId}`;
    const shareText = post_data.post_by ? `${post_data.post_by} — ConnectsApp` : 'ConnectsApp';

    const previewImage =
        post_data.images?.[0]?.image ||
        post_data.videos?.[0]?.thumbnail ||
        (post_data.url_details && post_data.url_details['image']) ||
        null;

    const share_post = (p_id) => {
        setLoading(true)
        API.post("/share_friend_post", {
            post_id: p_id,
            details: share_comment,
        }).then((response) => {
            setLoading(false)
            if (response.data.success === true) {
                setShareComment("")
                props.handleShowB()
                toast.success(t('Post Shared'))
            }
        }).catch((err) => {
            setLoading(false)
            props.handleShowB()
        });
    }

    const fallbackCopy = (done) => {
        const el = document.createElement('textarea');
        el.value = postUrl;
        el.style.position = 'fixed';
        el.style.opacity = '0';
        document.body.appendChild(el);
        el.select();
        try {
            document.execCommand('copy');
            done();
        } catch (e) {
            toast.error(t('Could not copy link'));
        }
        document.body.removeChild(el);
    };

    const copyLink = () => {
        const done = () => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        };
        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(postUrl).then(done).catch(() => fallbackCopy(done));
        } else {
            fallbackCopy(done);
        }
    };

    const openShare = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer,width=600,height=600');
    };

    const nativeShare = () => {
        if (navigator.share) {
            navigator.share({ title: shareText, url: postUrl }).catch(() => { });
        } else {
            copyLink();
        }
    };

    const socialTargets = [
        {
            key: 'whatsapp', label: 'WhatsApp',
            onClick: () => openShare(`https://wa.me/?text=${encodeURIComponent(`${shareText} ${postUrl}`)}`)
        },
        {
            key: 'facebook', label: 'Facebook',
            onClick: () => openShare(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postUrl)}`)
        },
        {
            key: 'x', label: 'X',
            onClick: () => openShare(`https://twitter.com/intent/tweet?url=${encodeURIComponent(postUrl)}&text=${encodeURIComponent(shareText)}`)
        },
        {
            key: 'telegram', label: 'Telegram',
            onClick: () => openShare(`https://t.me/share/url?url=${encodeURIComponent(postUrl)}&text=${encodeURIComponent(shareText)}`)
        },
        {
            key: 'linkedin', label: 'LinkedIn',
            onClick: () => openShare(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(postUrl)}`)
        },
        {
            key: 'email', label: t('Email'),
            onClick: () => { window.location.href = `mailto:?subject=${encodeURIComponent(shareText)}&body=${encodeURIComponent(postUrl)}`; }
        },
        {
            key: 'more', label: t('More'),
            onClick: nativeShare
        },
    ];

    return (
        <Modal
            isOpen={props.isModalVisible}
            toggle={props.handleShowB}
            centered
            modalClassName="psm-modal-root"
        >
            <div className="psm-header">
                <h6 className="psm-title">{t('Share Post')}</h6>
                <button type="button" className="psm-close" onClick={props.handleShowB} aria-label="Close">
                    <i className="fa-solid fa-xmark" />
                </button>
            </div>

            <div className="psm-body">
                {/* share to timeline */}
                <div className="psm-user">
                    <div className="psm-avatar" style={{ backgroundImage: `url(${myArr?.avatar})` }} />
                    <div>
                        <div className="psm-user-name">{myArr?.name}</div>
                        <span className="psm-user-scope">
                            <i className="fa-solid fa-globe" /> {t('Share to your timeline')}
                        </span>
                    </div>
                </div>

                <textarea
                    className="psm-textarea"
                    value={share_comment}
                    onChange={(e) => setShareComment(e.target.value)}
                    placeholder={t('Write something here')}
                    spellCheck="false"
                />

                {/* compact post preview */}
                <div className="psm-preview">
                    <div className="psm-preview-head">
                        <div className="psm-avatar psm-avatar--sm" style={{ backgroundImage: `url(${post_data.avatar})` }} />
                        <div>
                            <div className="psm-preview-name">{post_data.post_by}</div>
                            <div className="psm-preview-time">{post_data.post_time}</div>
                        </div>
                    </div>
                    {(post_data.is_shared_post ? post_data.self_details : post_data.details) ?
                        <div
                            dir="auto"
                            className="psm-preview-text"
                            dangerouslySetInnerHTML={{ __html: renderMarkdown(post_data.is_shared_post ? post_data.self_details : post_data.details) }}
                        />
                        : null}
                    {previewImage ?
                        <div className="psm-preview-media" style={{ backgroundImage: `url(${previewImage})` }}>
                            {post_data.videos?.length > 0 && !post_data.images?.length ?
                                <span className="psm-preview-media-play"><i className="fa-solid fa-circle-play" /></span>
                                : null}
                            {post_data.images?.length > 1 ?
                                <span className="psm-preview-media-count">+{post_data.images.length - 1}</span>
                                : null}
                        </div>
                        : null}
                </div>

                <button
                    type="button"
                    className="psm-post-btn"
                    disabled={isLoading}
                    onClick={() => share_post(props.postId)}
                >
                    {isLoading ?
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                        : <i className="fa-solid fa-share" />}
                    {t('Post')}
                </button>

                <div className="psm-divider">{t('Or share via')}</div>

                {/* copy link */}
                <div className="psm-copy-row">
                    <span className="psm-copy-url">{postUrl}</span>
                    <button
                        type="button"
                        className={`psm-copy-btn ${copied ? 'psm-copy-btn--copied' : ''}`}
                        onClick={copyLink}
                    >
                        {copied ?
                            <><i className="fa-solid fa-check" /> {t('Copied')}</>
                            : <><i className="fa-regular fa-copy" /> {t('Copy')}</>}
                    </button>
                </div>

                {/* social apps */}
                <div className="psm-social-row">
                    {socialTargets.map((s) => (
                        <button key={s.key} type="button" className="psm-social-item" onClick={s.onClick}>
                            <span className="psm-social-icon">{SocialIcons[s.key]}</span>
                            <span className="psm-social-label">{s.label}</span>
                        </button>
                    ))}
                </div>
            </div>
        </Modal>
    )
}
